module.exports = __webpack_public_path__ + "static/media/setup.e6104635.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/setup.svg
// module id = 523
// module chunks = 0